import React, { useState, useEffect, useRef } from 'react'

import axios from 'axios';
import InfiniteScroll from "react-infinite-scroll-component";
import {useTranslation} from 'react-i18next'
import {useNavigate, useLocation, Link} from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert';

import * as CONSTANTS from '../../Constants';
import * as COMMONFUNCTIONS from '../../utils/CommonFunctions';

import LeftSearch from '../../components/common/member_left_search';
import Login_Notice_Modal from '../../components/common/modals/login_notice_modal';
import Member_Profile_Modal from '../../components/common/modals/member_profile_modal';
//import RightResult from '../../components/common/member_right_result';

import MemberItems from '../../components/pages/member_items';

let home_search_params = {};
let temp_search_params = {};
let final_search_params = {};
let image_name = CONSTANTS.DEFAULT_PROFILE_IMAGE;
let page = 1;
let rcount = null;

let values = {};
 
const refresh = (setItems) => {};

const MemberFilterPanel = (props) => {

    const {t} = useTranslation();
    const [items, setItems] = React.useState([]);
    const navigate = useNavigate();

    const passed_params = useLocation();

    const [user_id] = useState(COMMONFUNCTIONS.getSession('member_id'));
    const [selectedMemberId, setSelectedMemberId] = useState(null);
    const [isLoggedIn] = useState(COMMONFUNCTIONS.getSession('isUserLoggedIn'));

    const [selectedMemberType, setSelectedMemberType] = useState(props.member_type);

    const [member_type, setMemberType] = useState(props.member_type);

    const [userData, setUserData] = useState({});
    const [userBasicInfoData, setUserBasicInfoData] = useState({});
    const [userPermanentAddressData, setUserPermanentAddressData] = useState({});
    const [userEducationCareerData, setUserEducationCareerData] = useState({});
    const [userSpiritualData, setUserSpiritualData] = useState({});
    const [userPhysicalData, setUserPhysicalData] = useState({});
    const [userLanguageData, setUserLanguageData] = useState({});
    
    const [isInterested, setInterested] = useState();
    const [isShortlisted, setShortlisted] = useState();
    const [isFollowed, setFollowed] = useState();
    const [isIgnored, setIgnored] = useState();
    const [isReported, setReported] = useState();

    const [isMemberSelected, setMemberSelected] = useState(false);

    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const [hasMore, setHasMore] = useState(true);
    const [mobFilterShow, setMobFilterShow] = useState('');
    const [listingViewClass, setListingViewClass] = useState('all-list-sh');
    const [gridIconClassActive, setGridIconClass] = useState('');
    const [listIconClassActive, setListIconClass] = useState('act');

    const [textLoginModal, setTextLoginModal] = useState();
    const [contentExpressModal, setContentExpressModal] = useState();
    const [expressModalHeaderText, setExpressModalHeaderText] = useState(t('confirm'));

    const modalOpenLoginBtnRef = useRef(null);
    const modalCloseLoginBtnRef = useRef(null);
    const modalOpenExpressBtnRef = useRef(null);
    const modalCloseExpressBtnRef = useRef(null);

    const modalOpenMemberProfileBtnRef = useRef(null);
    const modalCloseMemberProfileBtnRef = useRef(null);


    useEffect(() => {
        console.log(props.seoCaste);
        home_search_params.religion = 4;
        home_search_params.caste = props.seoCaste;
        home_search_params.caste_title = props.seoCasteTitle;
        /* if(states == null)
            changeCountry(101); */
    })

    const changeFilterGender = (event) => {
        //recordsListPanel = true;
        //console.log(event.target.value);
        temp_search_params['gender'] = event.target.value;
        temp_search_params['count'] = 0;
        final_search_params['count'] = 0;
        rcount = 0;
        setHasMore(true);
        fetchData(setItems,[])
    }

    const changeFilterAge = (event) => {
        //recordsListPanel = true;
        //console.log(event.target.value);
        temp_search_params['age_range'] = event.target.value;
        temp_search_params['count'] = 0;
        final_search_params['count'] = 0;
        rcount = 0;
        setHasMore(true);
        fetchData(setItems,[])
    }

    const changeFilterMemberId = (event) => {
        //recordsListPanel = true;
        //console.log(event.target.value);
        temp_search_params['member_id'] = event.target.value;
        temp_search_params['count'] = 0;
        final_search_params['count'] = 0;
        rcount = 0;
        setHasMore(true);
        fetchData(setItems,[])
    }

    const changeFilterMaritalStatus = (event) => {
        //recordsListPanel = true;
        //console.log(event.target.value);
        temp_search_params['marital_status'] = event.target.value;
        temp_search_params['count'] = 0;
        final_search_params['count'] = 0;
        rcount = 0;
        setHasMore(true);
        fetchData(setItems,[])
    }

    const changeFilterReligion = (event) => {
        //recordsListPanel = true;
        //console.log(event.target.value);
        temp_search_params['religion'] = event.target.value;
        temp_search_params['count'] = 0;
        final_search_params['count'] = 0;
        rcount = 0;
        setHasMore(true);
        fetchData(setItems,[])
    }

    const changeFilterCaste = (event) => {
        //recordsListPanel = true;
        console.log(event);

        let selectedCastes = [];
        if(event.length > 0)
        {
            for (let index = 0; index < event.length; index++) {
                selectedCastes.push(event[index].value);
            }
        }

        temp_search_params['caste'] = selectedCastes.join();
        temp_search_params['count'] = 0;
        final_search_params['count'] = 0;
        rcount = 0;
        setHasMore(true);
        fetchData(setItems,[])
    }

    const changeFilterLanguage = (event) => {
        //recordsListPanel = true;
        //console.log(event.target.value);
        temp_search_params['language'] = event.target.value;
        temp_search_params['count'] = 0;
        final_search_params['count'] = 0;
        rcount = 0;
        setHasMore(true);
        fetchData(setItems,[])
    }

    const changeFilterProfession = (event) => {
        //recordsListPanel = true;
        //console.log(event.target.value);
        temp_search_params['profession'] = event.target.value;
        temp_search_params['count'] = 0;
        final_search_params['count'] = 0;
        rcount = 0;
        setHasMore(true);
        fetchData(setItems,[])
    }

    const changeFilterEducation = (event) => {
        temp_search_params['highest_education'] = event.target.value;
        temp_search_params['count'] = 0;
        final_search_params['count'] = 0;
        rcount = 0;
        setHasMore(true);
        fetchData(setItems,[])
    }

    const changeFilterCountry = (event) => {
        //recordsListPanel = true;
        //console.log(event.target.value);
        temp_search_params['country'] = event.target.value;
        temp_search_params['count'] = 0;
        final_search_params['count'] = 0;
        rcount = 0;
        setHasMore(true);
        fetchData(setItems,[])
    }

    const changeFilterState = (event) => {
        //recordsListPanel = true;
        //console.log(event.target.value);
        temp_search_params['state'] = event.target.value;
        temp_search_params['count'] = 0;
        final_search_params['count'] = 0;
        rcount = 0;
        setHasMore(true);
        fetchData(setItems,[])
    }

    const changeFilterCity = (event) => {
        //recordsListPanel = true;
        //console.log(event.target.value);
        temp_search_params['city'] = event.target.value;
        temp_search_params['count'] = 0;
        final_search_params['count'] = 0;
        rcount = 0;
        setHasMore(true);
        fetchData(setItems,[])
    }

    const changeFilterMemberType = (event) => {
        //recordsListPanel = true;
        //console.log(event.target.value);
        setMemberType(null);
        temp_search_params['search_member_type'] = event.target.value;
        temp_search_params['count'] = 0;
        final_search_params['count'] = 0;
        rcount = 0;
        setHasMore(true);
        fetchData(setItems,[]);
        setSelectedMemberType(event.target.value);
    }

    const fetchUserProfileData = async (member_id) => {
        try {
            values[CONSTANTS.REST_KEY_NAME] = CONSTANTS.REST_KEY_VALUE;
            values['member_id'] = member_id;
            values['user_id'] = user_id;

            axios.post(CONSTANTS.SERVER_BASE_URL+'/api/main/member_profile',values, {headers: COMMONFUNCTIONS.getPostHeaders()})
                .then(response => {
                    //console.log(response);
                    if(response.data.success)
                    {
                        console.log(response);
                        setMemberSelected(true);
                        setAllUsersData(response.data.member_data);
                        /* if(Object.keys(userData).length < 1)
                        {
                            setAllUsersData(response.data.member_data);
                        } */
                        //console.log(userData);
                    }
                    else
                        COMMONFUNCTIONS.commonMessageErrorToast(response.data.message);
                })
                .catch(error => {
                    console.log(error);
                    if(error.response !== undefined && error.response !== '' && error.response !== null)
                        COMMONFUNCTIONS.commonMessageErrorToast(error.response.data.message);
                    else
                        COMMONFUNCTIONS.commonMessageErrorToast(error.message);
                });
            
        } catch (error) {
            setError(error);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchData = (setItems, items) => {
        final_search_params = temp_search_params;
        final_search_params[CONSTANTS.REST_KEY_NAME] = CONSTANTS.REST_KEY_VALUE;
        final_search_params['count'] = rcount;
        final_search_params['method'] = 'search';
        //final_search_params['search_member_type'] = 'all';
        if(member_type !== null)
        {
            //console.log(member_type);
            final_search_params['search_member_type'] = member_type;
        }

        if(isLoggedIn)
        {
            final_search_params['user_id'] = user_id;
        }
        else if(page > 1)
        {
            setTextLoginModal('Please Log In To View More Profiles.');
            modalOpenLoginBtnRef.current.click();
            setHasMore(false);
            return false;
        }

        //console.log(final_search_params);
        /* if(Object.keys(params_to_search).length > 0)
        {
            final_search_params = params_to_search;
        } */

        /* alert(Object.keys(params_to_search).length);
        alert(Object.keys(temp_search_params).length);
        alert(Object.keys(search_params).length); */

        if(typeof final_search_params.age_range !== 'undefined' && final_search_params.age_range !== '' && final_search_params.age_range !== null)
        {
            //console.log('age_range::'+final_search_params.age_range);

            let age_array = final_search_params.age_range.split('-');

            //console.log(age_array);

            final_search_params['aged_from'] = age_array[0];
            final_search_params['aged_to'] = age_array[1];
        }

        //axios.get(`https://jsonplaceholder.typicode.com/photos?_page=${page}&_limit=10`)
        axios.post(CONSTANTS.SERVER_BASE_URL+'/api/auth/ajax_member_list',final_search_params, {headers: COMMONFUNCTIONS.getPostHeaders()})
        .then((res) => {
        //console.log(res);
        if(res.data.count < 10)
        {
            //setIsLoading(false);
            setHasMore(false);
            if(res.data.count < 1)
                COMMONFUNCTIONS.commonMessageErrorToast('No more data to load.');
        }
        setItems([...items, ...res.data.records]);
        page = page + 1;
        rcount = rcount + 10;
        //console.log(rcount);
        });
    };

    function setAllUsersData (user_data)
    {
        console.log(user_data);
        setUserData(user_data);
        setUserBasicInfoData(user_data.basic_info);
        setUserPermanentAddressData(user_data.permanent_address);
        setUserEducationCareerData(user_data.education_and_career);
        setUserSpiritualData(user_data.spiritual_and_social_background);
        setUserPhysicalData(user_data.physical_attributes);
        setUserLanguageData(user_data.language);

        setInterested(user_data.is_interested);
        setShortlisted(user_data.is_shortlisted);
        setFollowed(user_data.is_followed);
        setIgnored(user_data.is_ignored);
        setReported(user_data.is_reported);
    }

    function updateExpressInterest(member_id)
    {
        if (isLoggedIn)
        {
            let act_status = saveExpressInterest(user_id ,member_id);

            //modalCloseExpressBtnRef.current.click();
        }
		else
		{
			setTextLoginModal('Please Log In To Express Interest On This Member.');
            modalOpenLoginBtnRef.current.click();
		}
    }

    function saveExpressInterest(user_id, member_id)
    {
        values['user_id'] = user_id;
        values['member_id'] = member_id;
        values[CONSTANTS.REST_KEY_NAME] = CONSTANTS.REST_KEY_VALUE;

        let resp_status = false;
    
        axios.post(CONSTANTS.SERVER_BASE_URL+'/api/main/add_interest',values, {headers: COMMONFUNCTIONS.getPostHeaders()})
        .then(response => {
            //console.log(response);
            if(response.data.success)
            {
                COMMONFUNCTIONS.commonMessageSuccessToast(response.data.message);
                resp_status = true;
                //setStates(response.data.state_data);
                setInterested(true);
            }
            else
            {
                COMMONFUNCTIONS.commonMessageErrorToast(response.data.message);
                resp_status = false;
                setInterested(false);
            }
        })
        .catch(error => {
            console.log(error);
            //if(error.response.data.message.length > 0)
            /* if(error.response !== undefined && error.response !== '' && error.response !== null)
                COMMONFUNCTIONS.commonMessageErrorToast(error.response.data.message);
            else
                COMMONFUNCTIONS.commonMessageErrorToast(error.message); */
        });
    }

    function gotoUserProfile(member_id)
    {
        //console.log(member_id);
        navigate("/profile-details.html", { state: {member_id : member_id}, replace: true });
    }

    function openMemberProfileModal(member_id)
    {
        console.log(member_id);
        fetchUserProfileData(member_id);
        modalOpenMemberProfileBtnRef.current.click();
    }

    function changeRecordLayout(type)
    {
        if(type == 'grid') {
            setGridIconClass('act');
            setListIconClass('');
            setListingViewClass('all-list-sh view-grid');
        }
        else{
            setGridIconClass('');
            setListIconClass('act');
            setListingViewClass('all-list-sh');
        }
    }

    function getProfileImage(img_obj)
    {
        //console.log(img_obj);
        let profile_image = "/assets/images/profiles/profile-large.jpg?x="+CONSTANTS.RANDOM_PWD;
        if(img_obj !== undefined)
        {
            //console.log(img_obj);
            let image_json_data = JSON.parse(img_obj);

            if(image_json_data[0].profile_image.length > 1)
                image_name = image_json_data[0].profile_image;

            profile_image = CONSTANTS.SERVER_BASE_URL.concat(CONSTANTS.PROFILE_DIR_PATH, image_name);
        }

        /* let profile_image = "/assets/images/profiles/profile-large.jpg?x="+CONSTANTS.RANDOM_PWD;

        if(img_obj.profile_image !== undefined)
            profile_image = CONSTANTS.SERVER_BASE_URL.concat(CONSTANTS.PROFILE_DIR_PATH, img_obj.profile_image); */

        return <img src={profile_image} alt="" />;
    }

    function getMemberImage(userData)
    {
        //console.log(userData);
        //console.log(userData.profile_image);
        let profile_image = '';
        if(Object.keys(userData).length !== 0)
        {
            //console.log(userData.profile_image.profile_image);
            if(userData.profile_image.profile_image.length > 1)
            {
                image_name = userData.profile_image.profile_image;
                profile_image = CONSTANTS.SERVER_BASE_URL.concat(CONSTANTS.PROFILE_DIR_PATH, image_name);
            }
            else
            {
                if(userData.gender_id == '2')
                    profile_image = 'http://localhost/projects/lagnasohala/matrimony_2/uploads/profile_image/default_w.png';
                else
                    profile_image = 'http://localhost/projects/lagnasohala/matrimony_2/uploads/profile_image/default_m.png';
            }
        }
        else
        {
            if(userData.gender_id == '2')
                profile_image = 'http://localhost/projects/lagnasohala/matrimony_2/uploads/profile_image/default_w.png';
            else
                profile_image = 'http://localhost/projects/lagnasohala/matrimony_2/uploads/profile_image/default_m.png';
        }
        
        console.log(profile_image);

        return <img src={profile_image} alt={ COMMONFUNCTIONS.camelCase(userData.first_name+' '+userData.last_name) } title={ COMMONFUNCTIONS.camelCase(userData.first_name+' '+userData.last_name) } />;
    }

    function gotoLogin()
    {
        COMMONFUNCTIONS.moveToTop();
        navigate("/login.html");
    }

    function gotoShortlist (member_id)
	{
        if (isLoggedIn)
        {
            /* var remainingInterest = COMMONFUNCTIONS.getUsersRemainingInterests(user_id);
            this.AlertProLoader.open();
            
            setTimeout(
                () =>
                {
                    console.log(remainingInterest._55);
                    this.setState({
                        remaining_interest_count : remainingInterest._55,
                        alert_message : "Remaining Express Interest(s): "+remainingInterest._55,
                    });
                    //alert_message = "Remaining Express Interest(s): "+this.state.remaining_interest_count;
                    this.AlertPro.open();
                    this.AlertProLoader.close();
                },
                3000
              ); */
        }
        else
		{
            props.setTextLoginModal('Please Log In To Shortlist This Member.');
            props.modalOpenLoginBtnRef.current.click();
		}
    }

    function saveShortlist (user_id, member_id)
    {
        //console.log(user_id+'==='+member_id+'==='+selected_member_id);
        if (isLoggedIn)
        {
            values['user_id'] = user_id;
            values['member_id'] = member_id;
            values[CONSTANTS.REST_KEY_NAME] = CONSTANTS.REST_KEY_VALUE;

            axios.post(CONSTANTS.SERVER_BASE_URL+'/api/main/add_shortlist',values, {headers: COMMONFUNCTIONS.getPostHeaders()})
            .then(response => {
                //console.log(response);
                if(response.data.success)
                {
                    COMMONFUNCTIONS.commonMessageSuccessToast(response.data.message);
                    setShortlisted(true);
                }
                else
                {
                    COMMONFUNCTIONS.commonMessageErrorToast(response.data.message);
                    setShortlisted(false);
                }
            })
            .catch(error => {
                console.log(error);
            });
        }
        else
        {
            props.setTextLoginModal('Please Log In To Shortlist This Member.');
            props.modalOpenLoginBtnRef.current.click();
        }
    }
    
    function removeShortlist (user_id, member_id)
    {
        if (isLoggedIn)
        {
            values['user_id'] = user_id;
            values['member_id'] = member_id;
            values[CONSTANTS.REST_KEY_NAME] = CONSTANTS.REST_KEY_VALUE;

            axios.post(CONSTANTS.SERVER_BASE_URL+'/api/main/remove_shortlist',values, {headers: COMMONFUNCTIONS.getPostHeaders()})
            .then(response => {
                //console.log(response);
                if(response.data.success)
                {
                    COMMONFUNCTIONS.commonMessageSuccessToast(response.data.message);
                    setShortlisted(false);
                }
                else
                {
                    COMMONFUNCTIONS.commonMessageErrorToast(response.data.message);
                    setShortlisted(true);
                }
            })
            .catch(error => {
                console.log(error);
            });
        }
        else
        {
            props.setTextLoginModal('Please Log In To Remove This Member From Shortlist.');
            props.modalOpenLoginBtnRef.current.click();
        }
    }

    function saveFollowlist (user_id, member_id)
    {
        if (isLoggedIn)
        {
            values['user_id'] = user_id;
            values['member_id'] = member_id;
            values[CONSTANTS.REST_KEY_NAME] = CONSTANTS.REST_KEY_VALUE;

            axios.post(CONSTANTS.SERVER_BASE_URL+'/api/main/add_follow',values, {headers: COMMONFUNCTIONS.getPostHeaders()})
            .then(response => {
                //console.log(response);
                if(response.data.success)
                {
                    COMMONFUNCTIONS.commonMessageSuccessToast(response.data.message);
                    setFollowed(true);
                }
                else
                {
                    COMMONFUNCTIONS.commonMessageErrorToast(response.data.message);
                    setFollowed(false);
                }
            })
            .catch(error => {
                console.log(error);
            });
        }
        else
        {
            props.setTextLoginModal('Please Log In To Follow This Member.');
            props.modalOpenLoginBtnRef.current.click();
        }
    }
    
    function addUnfollowList (user_id, member_id)
    {
        if (isLoggedIn)
        {
            values['user_id'] = user_id;
            values['member_id'] = member_id;
            values[CONSTANTS.REST_KEY_NAME] = CONSTANTS.REST_KEY_VALUE;

            axios.post(CONSTANTS.SERVER_BASE_URL+'/api/main/add_unfollow',values, {headers: COMMONFUNCTIONS.getPostHeaders()})
            .then(response => {
                //console.log(response);
                if(response.data.success)
                {
                    COMMONFUNCTIONS.commonMessageSuccessToast(response.data.message);
                    setFollowed(false);
                }
                else
                {
                    COMMONFUNCTIONS.commonMessageErrorToast(response.data.message);
                    setFollowed(true);
                }
            })
            .catch(error => {
                console.log(error);
            });
        }
        else
        {
            props.setTextLoginModal('Please Log In To Un-Follow This Member.');
            props.modalOpenLoginBtnRef.current.click();
        }
    }

    function saveIgnorelist (user_id, member_id)
    {
        if (isLoggedIn)
        {
            values['user_id'] = user_id;
            values['member_id'] = member_id;
            values[CONSTANTS.REST_KEY_NAME] = CONSTANTS.REST_KEY_VALUE;

            axios.post(CONSTANTS.SERVER_BASE_URL+'/api/main/add_ignore',values, {headers: COMMONFUNCTIONS.getPostHeaders()})
            .then(response => {
                //console.log(response);
                if(response.data.success)
                {
                    COMMONFUNCTIONS.commonMessageSuccessToast(response.data.message);
                    isIgnored(true);
                }
                else
                {
                    COMMONFUNCTIONS.commonMessageErrorToast(response.data.message);
                    isIgnored(false);
                }
            })
            .catch(error => {
                console.log(error);
            });
        }
        else
        {
            props.setTextLoginModal('Please Log In To Ignore This Member.');
            props.modalOpenLoginBtnRef.current.click();
        }
    }

    function gotoExpressInterest (member_id)
	{
        if (isLoggedIn)
        {
            COMMONFUNCTIONS.getUsersRemainingInterests(user_id);
            //this.AlertProLoader.open();
            
            setTimeout(
                () =>
                {
                    props.setSelectedMemberId(member_id);
                    var rem_interests = COMMONFUNCTIONS.getSession('user_interest_count');
                    /* //console.log(COMMONFUNCTIONS.getSession('user_interest_count'));
                    props.setExpressModalHeaderText(t('confirm_express_interest'));
                    props.setContentExpressModal(<p class='text-center'><b>{t('you_have_remaining_express_interest') +' '+ rem_interests +' '+ t('times')}</b><br/><br/><span>**N.B. {t('expressing_an_interest_will_cost_1_from_your_remaining_interests')}**</span></p>)

                    props.modalOpenExpressBtnRef.current.click();
                    setInterested(true); */

                    confirmAlert({
                        customUI: ({ onClose }) => {
                                return (<div class="modal fade show" id="expression_modal" aria-modal="true" style={{paddingRight: '15px',display: 'block'}}><div class="modal-dialog modal-md"><div class="modal-content notification-modal"><div class="modal-header"><h4 class="modal-title seninter-tit"><span class="intename2">{t('confirm_express_interest')}</span></h4><button type="button" class="close" data-dismiss="modal">×</button></div><div class="modal-body seninter"><div class="text-center"><p class="text-center"><b>{t('you_have_remaining_express_interest') +' '+ rem_interests +' '+ t('times')}</b><br/><br/><span>**N.B. {t('expressing_an_interest_will_cost_1_from_your_remaining_interests')}**</span></p></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" onClick={() => {
                                    //this.handleClickConfirm();
                                    props.updateExpressInterest(member_id);
                                    setInterested(true);
                                    setTimeout(() =>{onClose();},1000);                                    
                                  }}>Confirm</button><button type="button" class="btn btn-outline-danger"  onClick={onClose} data-dismiss="modal">Cancel</button></div></div></div>
                                  </div>
                                );
                            }
                      }); 

                },
                1000
              );
        }
        else
		{
            props.setTextLoginModal('Please Log In To Express Interest On This Member.');
            props.modalOpenLoginBtnRef.current.click();
            /* COMMONFUNCTIONS.commonMessageInfoToast('Please Log In To Express Interest On This Member.');
            setTimeout(() => { gotoLogin(); }, 2000); */
		}
    }

    function gotoIgnore (member_id)
	{
        if (isLoggedIn)
        {
            confirmAlert({
                customUI: ({ onClose }) => {
                        return (<div class="modal fade show" id="expression_modal" aria-modal="true" style={{paddingRight: '15px',display: 'block'}}><div class="modal-dialog modal-md"><div class="modal-content notification-modal"><div class="modal-header"><h4 class="modal-title seninter-tit"><span class="intename2">{t('confirm_ignore')}</span></h4><button type="button" class="close" data-dismiss="modal">×</button></div><div class="modal-body seninter"><div class="text-center"><p class="text-center"><b>{t('are_you_sure_that_you_want_to_ignore_this_member?')}</b></p></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" onClick={() => {
                            //this.handleClickConfirm();
                            saveIgnorelist(user_id ,member_id);
                            setIgnored(true);
                            setTimeout(() =>{onClose();},1000);                                    
                          }}>Confirm</button><button type="button" class="btn btn-outline-danger"  onClick={onClose} data-dismiss="modal">Cancel</button></div></div></div>
                          </div>
                        );
                    }
              }); 
        }
        else
		{
			props.setTextLoginModal('Please Log In To Ignore This Member.');
            props.modalOpenLoginBtnRef.current.click();
		}
    }

    return(
        <section>
            <div class="all-weddpro all-jobs all-serexp">
                <div class="container">
                    <div class="row">
                        <div class="col-md-3 form-select fil-mob-view" id="filter_search_panel" style={{display:mobFilterShow}}>
                            <LeftSearch search_params={home_search_params} changeFilterGenderFunction={changeFilterGender} changeFilterAgeFunction={changeFilterAge} changeFilterMemberIdFunction={changeFilterMemberId} changeFilterMaritalStatusFunction={changeFilterMaritalStatus} changeFilterReligionFunction={changeFilterReligion} changeFilterCasteFunction={changeFilterCaste} changeFilterProfessionFunction={changeFilterProfession} changeFilterEducationFunction={changeFilterEducation} changeFilterCountryFunction={changeFilterCountry} changeFilterStateFunction={changeFilterState} changeFilterCityFunction={changeFilterCity} changeFilterMemberTypeFunction={changeFilterMemberType} changeFilterLanguageFunction={changeFilterLanguage} fetchData={fetchData} setMobFilterShow={setMobFilterShow} member_type={member_type} selectedMemberType={selectedMemberType} setItems={setItems} isSeoPage={props.isSeoPage} modalOpenLoginBtnRef={modalOpenLoginBtnRef} modalOpenMemberProfileBtnRef={modalOpenMemberProfileBtnRef} />
                        </div>
                        <div class="col-md-9">
                            <div class="short-all">
                                <div class="short-lhs">
                                    {/* Showing <b>32</b> profiles */}
                                </div>
                                <div class="short-rhs">
                                    <ul>
                                        <li>
                                            Sort by:
                                        </li>
                                        <li>
                                            <div class="form-group">
                                                <select class="chosen-select">
                                                    <option value="">Most relative</option>
                                                    <option value="Men">Date listed: Newest</option>
                                                    <option value="Men">Date listed: Oldest</option>
                                                </select>
                                            </div>
                                        </li>
                                        <li>
                                            <div class= {"sort-grid sort-grid-1 "+gridIconClassActive} onClick={() => { changeRecordLayout('grid'); }}>
                                                <i class="fa fa-th-large" aria-hidden="true"></i>
                                            </div>
                                        </li>
                                        <li>
                                            <div class={"sort-grid sort-grid-2 "+listIconClassActive} onClick={() => { changeRecordLayout('list'); }}>
                                                <i class="fa fa-bars" aria-hidden="true"></i>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class={listingViewClass}>
                                <ul>
                                    <InfiniteScroll
                                        dataLength={items.length} //This is important field to render the next data
                                        next={() => {
                                            fetchData(setItems, items);
                                        }}
                                        hasMore={hasMore}
                                        loader={<h4><center>Loading...</center></h4>}
                                        /* endMessage={
                                        <p style={{ textAlign: "center" }}>
                                            <b>Yay! You have seen it all</b>
                                        </p>
                                        } */
                                        // below props only if you need pull down functionality
                                        refreshFunction={refresh}
                                        endMessage={<p><center>No more data to load.</center></p>}
                                        /* pullDownToRefresh
                                        pullDownToRefreshThreshold={50}
                                        pullDownToRefreshContent={
                                            <h3 style={{ textAlign: "center" }}># 8595; Pull down to refresh</h3>
                                        }
                                        releaseToRefreshContent={
                                            <h3 style={{ textAlign: "center" }}># 8593; Release to refresh</h3>
                                        } */
                                    >
                                        <div style={{ minHeight: "0" }}>
                                        { items.map(item => (
                                                <MemberItems item={item} setTextLoginModal={setTextLoginModal} modalOpenLoginBtnRef={modalOpenLoginBtnRef} modalOpenExpressBtnRef={modalOpenExpressBtnRef}
                                                modalOpenMemberProfileBtnRef={modalOpenMemberProfileBtnRef}modalCloseMemberProfileBtnRef={modalCloseMemberProfileBtnRef}
                                                openMemberProfileModal={openMemberProfileModal}
                                                setContentExpressModal={setContentExpressModal} setExpressModalHeaderText={setExpressModalHeaderText} setSelectedMemberId={setSelectedMemberId} updateExpressInterest={updateExpressInterest} getProfileImage={getProfileImage} gotoUserProfile={gotoUserProfile} />
                                            ))}
                                        </div>
                                    </InfiniteScroll>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Login_Notice_Modal textLoginModal={textLoginModal} gotoLogin={gotoLogin} modalCloseLoginBtnRef={modalCloseLoginBtnRef} />
            <Member_Profile_Modal userData={userData} userBasicInfoData={userBasicInfoData} userEducationCareerData={userEducationCareerData} userSpiritualData={userSpiritualData} userPermanentAddressData={userPermanentAddressData} userLanguageData={userLanguageData} isLoggedIn={isLoggedIn} isMemberSelected={isMemberSelected} setMemberSelected={setMemberSelected} getMemberImage={getMemberImage} modalCloseMemberProfileBtnRef={modalCloseMemberProfileBtnRef} />
        </section>
    )
}
export default MemberFilterPanel;